export enum ProfileTypeEnum {
  User = 'User',
  Store = 'Store',
}
